var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18608 6.48681L9.19098 4.50263L1.41243 0.170393C1.12378 0.00972083 0.861639 -0.0274936 0.638672 0.0179907L7.18608 6.48681Z",
    fill: "#434343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0879812 0.478027C0.0325407 0.617434 0 0.779287 0 0.967722V13.027C0 13.2154 0.0313349 13.3755 0.0855703 13.5131L6.67817 6.98879L0.0879812 0.478027Z",
    fill: "#434343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1882 7.49414L0.634766 13.9807C0.858336 14.0291 1.12288 13.9925 1.41455 13.8301L9.20696 9.48836L7.1882 7.49414Z",
    fill: "#434343"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2627 6.21127L9.84378 4.86328L7.69727 6.98864L9.85884 9.12463L12.2627 7.7855C13.0406 7.35311 13.0406 6.64426 12.2627 6.21127Z",
    fill: "#434343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/AndroidIcon.8b0bc7d40cf56c30358b131f53246004.svg";
export { ForwardRef as ReactComponent };